import { DayPart, ScheduleOption } from "../../gql/types";

export const formatFirstScheduleOption = (scheduleOptions: ScheduleOption[]): { date: string, time: string } => {
    if (!scheduleOptions || scheduleOptions.length === 0) return { date: "TBD", time: "TBD" };

    // Find the first option with a date.
    const option = scheduleOptions.find(opt => !!opt.date);
    if (!option || !option.date) return { date: "TBD", time: "TBD" };

    const isOnlyOption = scheduleOptions.length == 1;

    // Format the date as "Sat, Dec 14"
    const dateObj = new Date(option.date);
    const formattedDate = dateObj.toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric"
    });
    const dateStr = isOnlyOption
        ? `${formattedDate}`
        : `TBD (${formattedDate}...)`

    if (!isOnlyOption) {
        return { date: dateStr, time: "TBD" }
    }

    if (option.dayPart) {
        let dayPart: string;
        switch (option.dayPart) {
            case DayPart.Morning:
                dayPart = "Morning";
                break;
            case DayPart.EarlyAfternoon:
                dayPart = "Early Afternoon";
                break;
            case DayPart.LateAfternoon:
                dayPart = "Late Afternoon";
                break;
            case DayPart.Evening:
                dayPart = "Evening";
                break;
        }
        return { date: dateStr, time: dayPart };
    }
    // Otherwise, if startTime exists, show them.
    if (option.startTime) {
        const startTimeStr = new Date(option.startTime).toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "numeric"
        });
        return { date: dateStr, time: startTimeStr };
    }

    return { date: dateStr, time: "TBD" };
};

export const formatFinalScheduleOption = (scheduleOptions?: ScheduleOption[] | null): { date: string, time: string } => {
    if (!scheduleOptions || scheduleOptions === null || scheduleOptions.length === 0) return { date: "TBD", time: "TBD" };

    // Find the first option with a date.
    const option = scheduleOptions.find(opt => !!opt.date);
    if (!option || !option.date) return { date: "TBD", time: "TBD" };

    const isOnlyOption = scheduleOptions.length == 1;

    // Format the date as "Sat, Dec 14"
    const dateObj = new Date(option.date);
    const formattedDate = dateObj.toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric"
    });
    const dateStr = isOnlyOption
        ? `${formattedDate}`
        : `${formattedDate},...`

    if (option.dayPart) {
        let dayPart: string;
        switch (option.dayPart) {
            case DayPart.Morning:
                dayPart = "Morning";
                break;
            case DayPart.EarlyAfternoon:
                dayPart = "Early Afternoon";
                break;
            case DayPart.LateAfternoon:
                dayPart = "Late Afternoon";
                break;
            case DayPart.Evening:
                dayPart = "Evening";
                break;
        }
        if (!isOnlyOption) {
            dayPart = `${dayPart},...`;
        }
        return { date: dateStr, time: dayPart };
    }
    // Otherwise, if startTime exists, show them.
    if (option.startTime) {
        let startTimeStr = new Date(option.startTime).toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "numeric"
        });
        if (!isOnlyOption) {
            startTimeStr = `${startTimeStr},...`;
        }
        return { date: dateStr, time: startTimeStr };
    }

    return { date: dateStr, time: "TBD" };
};